import { HEIGHT_SIZE, PALLETE } from './consts';
import type { DescendantLogoProps } from '.';

export const Compact = ({ size, color, testId }: DescendantLogoProps) => (
  <svg
    width={HEIGHT_SIZE[size]}
    height={HEIGHT_SIZE[size]}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testId}
  >
    <path
      d="M11.1155 34.1155L17.231 28L27.6274 38.3964L38.0238 28L44.1393 34.1155L27.6274 50.6274L11.1155 34.1155Z"
      fill={PALLETE[color].a}
      fillOpacity="0.25"
    />
    <path
      d="M11.1155 28L14.1733 24.9422L27.6274 38.3964L41.0816 24.9422L44.1393 28L27.6274 44.5119L11.1155 28Z"
      fill={PALLETE[color].a}
      fillOpacity="0.65"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1155 21.8845L27.6274 5.37259L44.1393 21.8845L27.6274 38.3964L11.1155 21.8845ZM17.231 21.8845L27.6274 11.4881L28.8505 12.7112L18.4541 23.1076L17.231 21.8845ZM30.6852 14.5458L20.2888 24.9422L21.5119 26.1653L31.9083 15.7689L30.6852 14.5458ZM23.3465 28L33.7429 17.6036L34.966 18.8267L24.5696 29.2231L23.3465 28ZM32.5199 24.9422L26.4043 31.0577L27.6275 32.2808L33.743 26.1653L32.5199 24.9422Z"
      fill={PALLETE[color].a}
    />
  </svg>
);
